import React from 'react';
import uuid from 'react-uuid';
import './title-with-description.scss';

function TitleWithDescription({ content, extraClassName = '' }) {
  return (
    <div className={`title-with-description${extraClassName}`}>
      <h3 className='title' dangerouslySetInnerHTML={{ __html: content?.title }} />
      <div className='description' dangerouslySetInnerHTML={{ __html: content?.description }} />
      {content.items && (
        <div className='description'>
          {content.items.map(item => {
            return <p key={`title-with-description-paragraph-${uuid()}`}>{item}</p>;
          })}
        </div>
      )}
    </div>
  );
}

export default TitleWithDescription;
